var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isUploading,
          expression: "isUploading",
        },
      ],
      staticClass: "voice-input-page",
    },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "step-label" }, [_vm._v("语音录入")]),
        _c("div", { staticClass: "divider" }),
        _c("div", { staticClass: "status-text" }, [
          _vm._v(_vm._s(_vm.statusText)),
        ]),
      ]),
      _c("div", { staticClass: "mic-section" }, [
        _c(
          "div",
          { staticClass: "mic-wrapper", on: { click: _vm.toggleRecording } },
          [
            _c("div", {
              staticClass: "mic-ring",
              class: { active: _vm.isRecording },
            }),
            _c("div", {
              staticClass: "mic-ring ring-2",
              class: { active: _vm.isRecording },
            }),
            _c(
              "div",
              { staticClass: "mic-btn", class: { recording: _vm.isRecording } },
              [
                _c("i", {
                  class: _vm.isRecording
                    ? "el-icon-video-pause"
                    : "el-icon-microphone",
                }),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "mic-hint" }, [
          _vm._v(
            _vm._s(_vm.isRecording ? "正在聆听，点击暂停" : "点击开始语音输入")
          ),
        ]),
      ]),
      _c("div", { staticClass: "text-panel" }, [
        _vm.interimResult
          ? _c("div", { staticClass: "text-line interim" }, [
              _vm._v(_vm._s(_vm.interimResult)),
            ])
          : _vm._e(),
        _vm.finalResult
          ? _c("div", { staticClass: "text-line final" }, [
              _vm._v(_vm._s(_vm.finalResult)),
            ])
          : _vm._e(),
        !_vm.interimResult && !_vm.finalResult
          ? _c("div", { staticClass: "placeholder" }, [
              _c("i", { staticClass: "el-icon-chat-line-round" }),
              _c("span", [_vm._v("语音内容将实时显示在这里")]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "footer-actions" }, [
        _c(
          "div",
          {
            staticClass: "action-btn btn-cancel",
            class: { disabled: _vm.isUploading },
            on: { click: _vm.handleCancel },
          },
          [_vm._v("取消")]
        ),
        _c(
          "div",
          {
            staticClass: "action-btn btn-confirm",
            class: { disabled: _vm.isUploading },
            on: { click: _vm.handleConfirm },
          },
          [_vm._v("确定")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }